import Header from "./components/Header/Header"
import Hero from "./components/Hero/Hero"
import Services from "./components/Services/Services"
import Projects from "./components/Projects/Projects"
import CatalogGallery from "./components/CatalogGallery/CatalogGallery"
import ResidentialCommercial from "./components/ResidentialCommercial/ResidentialCommercial"
import WhyChooseUs from "./components/WhyChooseUs/WhyChooseUs"
import Process from "./components/Process/Process"
import CTA from "./components/CTA/CTA"
import Footer from "./components/Footer/Footer"
import WhatsappButton from "./components/WhatsappButton/WhatsappButton"
import NoAdvancePromo from "./components/NoAdvancePromo/NoAdvancePromo"

function App() {
  return (
    <>
      <Header />
      <Hero />
      <Services />
      <NoAdvancePromo />
      <Projects />
      <CatalogGallery />
      <ResidentialCommercial />
      <WhyChooseUs />
      <Process />
      <CTA />
      <WhatsappButton />
      <Footer />
    </>
  )
}

export default App